import apiClient from '../apiClient.js'
import { parseAxiosException } from '@/helpers/exceptionParser.js'
import moduleForFetchable from '@v/store/moduleForFetchable.js'
import countries from './countries.js'

// this module contains environment and session state

class BriqState {
  constructor(rawModel) {
    this.envFeatureFlags = rawModel?.envFeatureFlags || null
    this.enabledFeatures = rawModel?.enabledFeatures || null
    this.integrationsInUse = rawModel?.integrationsInUse || null
    this.userIsAdvanced = rawModel?.userIsAdvanced || null
    this.userCanViewAuditTrail = rawModel?.userCanViewAuditTrail || null
    this.businessUnitKey = rawModel?.businessUnitKey || null
    this.businessUnitDomain = rawModel?.businessUnitDomain || null
    this.businessUnitDataCulture = rawModel?.businessUnitDataCulture || null
    this.priceIncludesTaxDefaultValue = rawModel?.priceIncludesTaxDefaultValue || null
    this.businessUnitStartOfDayTime = rawModel?.businessUnitStartOfDayTime || null
    this.userPermissions = rawModel?.userPermissions || []
    this.token = rawModel?.token
    this.businessUnitAdditionalFeatures = rawModel?.businessUnitAdditionalFeatures || null
  }
}

const module = moduleForFetchable({
  name: 'briqState',
  url: 'briqstate',
  toModel: x => new BriqState(x),
  apiClient,
})

module.getters.isFetchingBriqState = state => state.isFetching
module.getters.enabledFeatures = state => state.briqState.enabledFeatures
module.getters.userHasPermission = state => permission =>
  state.briqState.userPermissions?.includes(permission)
module.getters.envFeatureFlags = state => state.briqState.envFeatureFlags
module.getters.userCanViewAuditTrail = state => state.briqState.userCanViewAuditTrail
module.getters.businessUnitKey = state => state.briqState.businessUnitKey
module.getters.businessUnitStartOfDayTime = state => state.briqState.businessUnitStartOfDayTime
module.getters.businessUnitHasFeature = state => feature =>
  !!state.briqState?.enabledFeatures?.includes(feature)
module.getters.businessUnitHasIntegration = state => integration =>
  !!state.briqState?.integrationsInUse?.includes(integration)
module.getters.featureFlagIsEnabled = state => featureFlag =>
  state.briqState?.envFeatureFlags?.[featureFlag] === true
module.getters.businessUnitDataCulture = state => state.briqState.businessUnitDataCulture
module.getters.businessUnitAdditionalFeatures = state =>
  state.briqState.businessUnitAdditionalFeatures
module.getters.countries = () => countries

export default module
